<template>

    <div class="card card-default shadow">
        <!-- <div class="card-header">
          <div class="card-title">
            <button type="button" v-on:click="Print()" class="btn bg-custom btn-sm"> +print</button>
          </div>
        </div> -->
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Subject</label>
                        <select v-model="teacherID" class="form-control">
                            <option value="0">All</option>
                            <option v-for="item in courses" :value="item.TeacherCourseAllotmentID">{{item.CourseTitle}} - {{item.ClassName}}</option>
                        </select>
                        <!--<input class="form-control" disabled v-model="course.CourseTitle + ' - ' + course.ClassName" />-->
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mt-2">
                        <div class="table-responsive text-left">
                            <table class="table table-bordered table-sm " id="tbl">
                                <thead class="bg-custom">
                                    <tr>
                                        <th style="width: 10px" align="center">Sr.</th>
                                        <th>Subject</th>
                                        <th>Date</th>
                                        <th>Code</th>
                                        <th>Type</th>
                                        <th style="width: 8%">Total Marks</th>
                                        <th style="width: 8%">Marks Obtained</th>
                                        <th style="width: 8%">Percentage</th> 
                                    </tr>
                                </thead>
                                <tbody> 
                                    <tr v-for="(result, ind) in getList()">
                                        <td style="width: 10px" align="center">{{ind + 1}}</td> 
                                        <td>{{result.CourseTitle}} - {{result.ClassName}}</td> 
                                        <td>{{result.Date}}</td>
                                        <td>{{result.Code}}</td>
                                        <td>{{result.Type}}</td>
                                        <td align="center" style="width: 8%">{{result.TotalMarks}}</td>
                                        <td align="center" style="width: 8%">{{result.MarksObtained}}</td>
                                        <td align="center" style="width: 8%">{{result.Percentage.toFixed(0)}}</td>

                                        <!--<td style="white-space: nowrap;">
      <button v-on:click="print(result.AssessmentID)" type="button" class="btn bg-gradient-warning btn-xs">Print</button>
    </td>-->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>import axios from 'axios';
    export default {
        name: 'result',
        data() {
            return {
                courses: [],
                teacherID: 0,
                results: [],
            } 
        },
        created() {
            this.pageLoad();
        },
        updated() {
            $('#tbl').DataTable();
        },
        methods: {

            //show up list of data form in table from database
            pageLoad() {
                //var url = new URLSearchParams(window.location.search);
                //var id = url.get("teacherID")

                var vm = this;
                axios.post('/api/PortalApi/pageLoadAssessmentList')
                    .then(function (res) {
                        vm.courses = res.data.courses;
                        vm.results = res.data.results;
                    }); 
            },

            Print() {
                var url = new URLSearchParams(window.location.search);
                var id = url.get("teacherID")
                window.location.href = "/Portal/CourseResultPrint?teacherID=" + id;
            },

            getList() {
                var table = $('#tbl').DataTable();
                table.destroy();
                if (this.teacherID == 0)
                    return this.results;
                else
                    return this.results.filter((x) => { return x.TeacherCourseAllotmentID == this.teacherID });
            }


        }
    }</script>



// WEBPACK FOOTER //
// src/components/school/exams/result.vue